/*eslint-disable max-lines*/
import { GridConfig, VisionOutboundType } from '@hakimo-ui/hakimo/types';
import {
  FullScreenExitIcon,
  FullScreenIcon,
  MenuDropdown,
  MenuItem,
} from '@hakimo-ui/hakimo/ui-elements';
import { Button } from '@hakimo-ui/shared/ui-base';
import {
  PauseCircleIcon,
  PlayCircleIcon,
  SquaresPlusIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';
import { useScanWsMessageHandler } from '../../hooks/useScanWsMessageHandler';

interface Props {
  toggleFullScreen: () => void;
  isFullScreen: boolean;
  gridConfig: GridConfig;
  updateGridConfig: (config: GridConfig) => void;
  isPaused: boolean;
  togglePlayPause: () => void;
}

export function ScanToolbar(props: Props) {
  const {
    toggleFullScreen,
    isFullScreen,
    gridConfig,
    updateGridConfig,
    isPaused,
    togglePlayPause,
  } = props;

  const [unallocatedAlarmsCount, setUnallocatedAlarmsCount] = useState(0);
  const [totalPendingAlarms, setTotalPendingAlarms] = useState(0);
  const handleTotalCountUpdate = (payload: {
    total_alarms: number;
    total_unallocation_count: number;
  }) => {
    setUnallocatedAlarmsCount(payload.total_unallocation_count || 0);
    setTotalPendingAlarms(payload.total_alarms || 0);
  };
  useScanWsMessageHandler(
    VisionOutboundType.ALARM_COUNT,
    handleTotalCountUpdate
  );

  const gridMenuItems: MenuItem[] = [
    {
      name: '3 x 3 grid',
      onClick: () => updateGridConfig({ cols: 3, rows: 3 }),
      className:
        gridConfig.cols === 3 && gridConfig.rows === 3
          ? 'text-primary-500 dark:text-primary-500'
          : '',
    },
    {
      name: '4 x 4 grid',
      onClick: () => updateGridConfig({ cols: 4, rows: 4 }),
      className:
        gridConfig.cols === 4 && gridConfig.rows === 4
          ? 'text-primary-500 dark:text-primary-500'
          : '',
    },
    {
      name: '5 x 5 grid',
      onClick: () => updateGridConfig({ cols: 5, rows: 5 }),
      className:
        gridConfig.cols === 5 && gridConfig.rows === 5
          ? 'text-primary-500 dark:text-primary-500'
          : '',
    },
    {
      name: '6 x 6 grid',
      onClick: () => updateGridConfig({ cols: 6, rows: 6 }),
      className:
        gridConfig.cols === 6 && gridConfig.rows === 6
          ? 'text-primary-500 dark:text-primary-500'
          : '',
    },
  ];

  const menuButton = <SquaresPlusIcon className="h-6 w-6" />;

  return (
    <div className="flex flex-grow items-center justify-end gap-2">
      <span
        className={clsx('font-sans text-sm', isPaused && 'text-status-red')}
      >
        Unallocated [{unallocatedAlarmsCount}] / Total [{totalPendingAlarms}]
      </span>
      <Button
        variant="icon"
        onClick={togglePlayPause}
        title={`${isPaused ? 'Play' : 'Pause'} Scan`}
      >
        {isPaused ? (
          <PlayCircleIcon className="text-status-red h-7 w-7 " />
        ) : (
          <PauseCircleIcon className="h-7 w-7" />
        )}
      </Button>
      <div className="hidden">
        <MenuDropdown
          position="top"
          items={gridMenuItems}
          menuButton={menuButton}
        />
      </div>
      {/* TODO: remove hidden css and workout a way to adjust full screen with FullViewModal */}
      <Button variant="icon" onClick={toggleFullScreen} className="hidden">
        {isFullScreen ? (
          <FullScreenExitIcon className="dark:fill-ondark-text-1 h-7 w-7" />
        ) : (
          <FullScreenIcon className="dark:fill-ondark-text-1 h-7 w-7" />
        )}
      </Button>
    </div>
  );
}

export default ScanToolbar;
